import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as volumeAction from '../../../actions/volumeAction';

const VolumeItemList = (props) => {
  return (
    <div className="row" style={{ marginBottom: '0px' }}>
      <ul className="col s12" style={{ padding: '0', marginTop: '0' }}>{
        props.volumeItems && props.volumeItems.map((item, index) => {
          return (
            <li
              key={index}
              style={{ backgroundColor: 'white', boxShadow: '0 1px 5px 0 rgba(0,0,0,0.2)', padding: '4px' }}
            >
              <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                <div className="col s10">
                  <p className="crop-text-300 mdi mdi-page-next-outline"> {item.codigoCartellino} {item?.desenho?.shortDescription || ''}</p>
                </div>
                <div className="col s2" style={{ verticalAlign: 'middle', paddingTop: '10px' }}>
                  <i onClick={() => props.removedVolumeItem(item)} className="material-icons small sixth-text-color">delete</i>
                </div>
              </span>
            </li>
          );
        })
      }
      </ul>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
    volumeItems: state.volumeReducer.volumeItems,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removedVolumeItem: (item) => {
      dispatch(volumeAction.removedVolumeItem(item));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VolumeItemList));
